import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useThemeMode } from '../../ThemeContext';

// Import mobile screenshots
import Mobile1 from '../../assets/landing_page_images/mobile1.jpg';
import Mobile2 from '../../assets/landing_page_images/mobile2.jpg';
import Mobile3 from '../../assets/landing_page_images/mobile3.jpg';
import Mobile4 from '../../assets/landing_page_images/mobile4.jpg';

// Import store icons
import PlayStoreIcon from '../../assets/landing_page_images/playstore_icon.png';
import AppStoreIcon from '../../assets/landing_page_images/appstore_icon.png';

function MobileApps() {
  const { mode } = useThemeMode();
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const mobileScreenshots = [Mobile1, Mobile2, Mobile3, Mobile4];
  
  // Group screenshots into pairs (2 images per slide)
  const slides = [];
  for (let i = 0; i < mobileScreenshots.length; i += 2) {
    slides.push(mobileScreenshots.slice(i, i + 2));
  }
  
  // Auto-slide functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 4000); // Change slide every 4 seconds
    
    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <>
      {/* Mobile Apps Section */}
      <section className="mobile-apps-section py-5">
        <Container>
          <div className="text-center mb-5">
            <div className="mobile-apps-section-title">Take Compliance On The Go</div>
          </div>
          <Row className="align-items-center">
            <Col xs={12} lg={6} className="mb-5 mb-lg-0">
              <div className="mobile-apps-content">
                <div className="mobile-apps-subtitle">
                  Access Complimate anywhere, anytime with our mobile apps. Manage documents, run audits, track tasks, and get instant compliance answers all from your Android or iOS device.
                </div>
                <div className="mobile-apps-features">
                  <div className="mobile-apps-feature-item">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 16L14 12L10 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>Full access to all compliance features</span>
                  </div>
                  <div className="mobile-apps-feature-item">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 16L14 12L10 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>Offline access to your documents</span>
                  </div>
                  <div className="mobile-apps-feature-item">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 16L14 12L10 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>Photo audits and evidence capture</span>
                  </div>
                  <div className="mobile-apps-feature-item">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 16L14 12L10 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>Real-time sync across all devices</span>
                  </div>
                </div>
                <div className="mobile-apps-buttons">
                  <a 
                    href="https://play.google.com/store/apps/details?id=com.complimate" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="store-button store-button-google"
                    aria-label="Download on Google Play"
                  >
                    <img src={PlayStoreIcon} alt="Google Play" className="store-icon" />
                    <div className="store-button-label">Play Store</div>
                  </a>
                  <a 
                    href="https://apps.apple.com/us/app/complimate-app/id6756040647" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="store-button store-button-apple"
                    aria-label="Download on App Store"
                  >
                    <img src={AppStoreIcon} alt="App Store" className="store-icon" />
                    <div className="store-button-label">App Store</div>
                  </a>
                </div>
              </div>
            </Col>
            <Col xs={12} lg={6}>
              <div className="mobile-apps-screenshots">
                <div className="mobile-screenshot-slider">
                  <div className="slider-container">
                    <div 
                      className="slider-track" 
                      style={{ transform: `translateX(-${currentSlide * 100}%)` }}
                    >
                      {slides.map((slide, slideIndex) => (
                        <div key={slideIndex} className="slider-slide">
                          {slide.map((image, imageIndex) => (
                            <div key={imageIndex} className="mobile-screenshot-item">
                              <img 
                                src={image} 
                                alt={`Complimate Mobile App Screenshot ${slideIndex * 2 + imageIndex + 1}`} 
                                className="mobile-screenshot-img" 
                              />
                            </div>
                          ))}
                        </div>
                      ))}
                    </div>
                  </div>
                  
                  <div className="slider-dots">
                    {slides.map((_, index) => (
                      <button
                        key={index}
                        className={`slider-dot ${index === currentSlide ? 'active' : ''}`}
                        onClick={() => setCurrentSlide(index)}
                        aria-label={`Go to slide ${index + 1}`}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default MobileApps;

